import { useState, useEffect } from 'react'
import { useRouteMatch } from '@fs/zion-router'
import { activityGroupAllowedRoutes, subActivityGroupAllowedRoutes } from '../helpers/routes'

export default function useRelevantActivityGroupId() {
  const activityGroupRouteMatch = useRouteMatch(activityGroupAllowedRoutes)
  const subActivityRouteMatch = useRouteMatch(subActivityGroupAllowedRoutes)
  const routeMatch = subActivityRouteMatch || activityGroupRouteMatch

  const subActivityGroupId = routeMatch?.params?.subActivityGroupId
  const rootActivityGroupId = routeMatch?.params?.activityGroupId
  const routeDerivedActivityGroupId = subActivityGroupId ?? rootActivityGroupId

  const [customActivityGroupId, setCustomActivityGroupId] = useState(null)

  // When the route changes, we want to clear any custom override so the new route takes precedence.
  // This fixes a bug where navigating from one activity group to another (e.g. via back button or menu)
  // would keep the old activity group ID if we didn't reset this state.
  useEffect(() => {
    if (customActivityGroupId !== null) {
      setCustomActivityGroupId(null)
    }
  }, [routeDerivedActivityGroupId, customActivityGroupId])

  // Determine which activityGroupId should drive data fetching.
  // We allow a custom ID to override the route-derived ID (e.g. for feed overlays).
  const activityGroupId = resolveActivityGroupId(customActivityGroupId, routeDerivedActivityGroupId)

  const parentActivityGroupId = subActivityGroupId ? rootActivityGroupId : null

  return {
    activityGroupId,
    subActivityGroupId,
    rootActivityGroupId,
    parentActivityGroupId,
    setCustomActivityGroupId,
    routeMatch,
  }
}

function resolveActivityGroupId(customActivityGroupId, routeDerivedActivityGroupId) {
  if (customActivityGroupId != null && customActivityGroupId !== routeDerivedActivityGroupId)
    return customActivityGroupId
  return routeDerivedActivityGroupId
}
